import { defineStore } from "pinia";
import apiClient from "@/plugins/axios";

export const useSocialPostsStore = defineStore("social-posts", {
  state: () => ({
    posts: [],
    totalPages: 1,
    currentPage: 1,
    totalResults: 0,
    loading: false,
    error: "",

    platform: "all", // all | facebook | tiktok
    perPage: 12,
  }),

  actions: {
    async fetchSocialPosts(params = {}) {
      this.loading = true;
      this.error = "";

      try {
        const response = await apiClient.get("/public/social-posts", {
          params: {
            page: params.page ?? this.currentPage,
            platform: params.platform ?? this.platform,
            per_page: params.per_page ?? this.perPage,
          },
        });

        // Backend retorna paginate()
        const items = response.data.data ?? [];

        // Agregar campos solo de UI (front)
        this.posts = items.map((p) => ({
          ...p,
          playing: false,
          thumbnail: p.type === "tiktok" ? "" : null,
        }));

        this.currentPage = Number(response.data.current_page);
        this.totalPages = Number(response.data.last_page);
        this.totalResults = Number(response.data.total);

        // cargar miniaturas TikTok (si aplica)
        await this.loadTikTokThumbnails();
      } catch (error) {
        if (error.code === "ERR_NETWORK") {
          this.error =
            "No se pudo conectar al servidor. Por favor, intenta nuevamente más tarde.";
        } else {
          this.error =
            error.response?.data?.message ||
            "Error al cargar las publicaciones. Intente de nuevo más tarde.";
        }
      } finally {
        this.loading = false;
      }
    },

    async changePage(page) {
      this.currentPage = page;
      await this.fetchSocialPosts();
    },

    async changePlatform(platform) {
      this.platform = platform;
      this.currentPage = 1;
      await this.fetchSocialPosts({ page: 1, platform });
    },

    async loadTikTokThumbnails() {
      // Igual a tu lógica actual, pero sobre this.posts
      for (let post of this.posts) {
        if (post.type !== "tiktok") continue;
        if (post.thumbnail) continue;

        try {
          const api = `https://www.tiktok.com/oembed?url=${encodeURIComponent(
            post.url
          )}`;
          const resp = await fetch(api);
          const data = await resp.json();
          post.thumbnail = data.thumbnail_url || "";
        } catch (e) {
          console.warn("No se pudo obtener miniatura TikTok:", e);
        }
      }
    },

    resetStore() {
      this.posts = [];
      this.totalPages = 1;
      this.currentPage = 1;
      this.totalResults = 0;
      this.loading = false;
      this.error = "";
      this.platform = "all";
    },
  },
});
